import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

const SARLAFT_ATTEMPS_KEY = 'sarlaftAttemps';

@Component({
  selector: 'app-check-the-information',
  templateUrl: './check-the-information.component.html',
  styleUrl: './check-the-information.component.scss'
})
export class CheckTheInformationComponent {
  private router = inject(Router);

  private getAttemps(): number {
    return Number(sessionStorage.getItem(SARLAFT_ATTEMPS_KEY)) || 0;
  }

  retry(): void {
    const next = this.getAttemps() + 1;
    sessionStorage.setItem(SARLAFT_ATTEMPS_KEY, String(next));
    this.router
      .navigate(['/seguros/hogar/arriendo/cotizador/datos-propietario'])
      .then(() => {
        setTimeout(() => window.scrollTo(0, 0), 0);
      });
  }
}
